(function () {
  var RAZOR = 58903326982525;   // Rasoir Dermea
  var GIFT = 58903330947453;    // Coffret Gant Exfoliant, Sabot et Brosse de Nettoyage (0 EUR)
  var busy = false, again = false;
  var nativeFetch = window.fetch.bind(window);
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CART_RE = /\/cart\/(add|change|update|clear)/;

  function qty(cart, id) {
    var n = 0;
    (cart.items || []).forEach(function (i) { if (i.variant_id === id) n += i.quantity; });
    return n;
  }
  function post(url, body) {
    return window.fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  async function sync() {
    if (busy) { again = true; return; }
    busy = true;
    try {
      var cart = await (await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      var r = qty(cart, RAZOR), g = qty(cart, GIFT), want = r, changed = false;
      if (g !== want) {
        if (want > g) await post('cart/add.js', { items: [{ id: GIFT, quantity: want - g }] });
        else await post('cart/change.js', { id: String(GIFT), quantity: want });
        changed = true;
      }
      if (changed) document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) {}
    busy = false;
    if (again) { again = false; sync(); }
  }
  function bodyQty(init) {
    try {
      var b = init && init.body, q = 1;
      if (typeof FormData !== 'undefined' && b instanceof FormData) { q = parseInt(b.get('quantity'), 10); }
      else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) { q = parseInt(b.get('quantity'), 10); }
      else if (typeof b === 'string') { var m = b.match(/"quantity"\s*:\s*"?(\d+)/) || b.match(/quantity=(\d+)/); q = m ? parseInt(m[1], 10) : 1; }
      return q > 0 ? q : 1;
    } catch (e) { return 1; }
  }
  function bodyHasRazor(init) {
    try {
      var b = init && init.body; if (!b) return false;
      if (typeof FormData !== 'undefined' && b instanceof FormData) {
        return Array.from(b.entries()).some(function (e) { return /(^id$|\[id\]$)/.test(e[0]) && String(e[1]) === String(RAZOR); });
      }
      if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) return String(b.get('id')) === String(RAZOR);
      if (typeof b === 'string') return b.indexOf(String(RAZOR)) !== -1;
    } catch (e) {}
    return false;
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isCart = CART_RE.test(url);
    var pre = Promise.resolve();
    if (/\/cart\/add/.test(url) && bodyHasRazor(init)) {
      pre = nativeFetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var need = qty(c, RAZOR) + bodyQty(init) - qty(c, GIFT); if (need > 0) return post('cart/add.js', { items: [{ id: GIFT, quantity: need }] });
      }).catch(function () {});
    }
    return pre.then(function () {
      var p = nativeFetch(input, init);
      if (isCart) p.then(function () { setTimeout(sync, 300); }).catch(function () {});
      return p;
    });
  };
  var XO = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (CART_RE.test(String(u))) this.addEventListener('loadend', function () { setTimeout(sync, 300); });
    return XO.apply(this, arguments);
  };
  if (document.readyState !== 'loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('pageshow', function () { sync(); });
})();
